export default __webpack_public_path__ + "assets/images/b645be95644df96e7cd2cb698ed5b655.svg";